<script>

import GeneralMedicalIcon from "@/components/Common/Icons/GeneralMedicalIcon.vue";
import ManipulationsIcon from "@/components/Common/Icons/ManipulationsIcon.vue";
import CardiologyIcon from "@/components/Common/Icons/CardiologyIcon.vue";
import RadiologyIcon from "@/components/Common/Icons/RadiologyIcon.vue";
import SurgeryIcon from "@/components/Common/Icons/SurgeryIcon.vue";
import ArrowForwardIcon from "@/components/Common/Icons/ArrowForwardIcon.vue";


export default {
  name: "OneServiceCategoryButton",
  components: {ArrowForwardIcon, GeneralMedicalIcon, CardiologyIcon, ManipulationsIcon, SurgeryIcon, RadiologyIcon},
  props: {
    buttonText: {
      type: String
    },
    buttonTextHover: {
      type: String
    },
    buttonIcon: {
      type: String
    },
    theme: {
      type: String
    }
  },
}
</script>

<template>
  <div class="service-category-button d-flex align-items-center"
       v-bind:class="{
    'button-theme-solid-white': theme === 'solid-white',
    'button-theme-solid-grey': theme === 'solid-grey',

  }"
  >
    <div v-if="buttonIcon" class="icon-container d-flex justify-content-center align-items-center">
      <GeneralMedicalIcon v-if="buttonIcon === 'GeneralMedical'"/>
      <CardiologyIcon v-if="buttonIcon === 'Cardiology'"/>
      <ManipulationsIcon v-if="buttonIcon === 'Manipulations'"/>
      <SurgeryIcon v-if="buttonIcon === 'Surgery'"/>
      <RadiologyIcon v-if="buttonIcon === 'Radiology'"/>
    </div>
    <div class="ms-4">
      {{ buttonText }}
    </div>
    <div class="ms-auto me-5 button-text-hover">
      {{ buttonTextHover }}
    </div>
    <div class="me-5 button-text-hover icon-arrow-forward">
      <ArrowForwardIcon/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.service-category-button {

  width: 100%;
  padding: 10px;
  border-radius: 50px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  font-family: $font-semi-bold;
  font-size: $paragraph-2;

  .icon-container {
    background: $color-light-brown;
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }
}

.button-theme-solid-white {
  background: $color-white;
  color: $color-dark-brown;

  .button-text-hover {
    display: none;
    color: $color-white;
  }

}

.button-theme-solid-grey {
  background: $color-grey;
  color: $color-black;
  min-height: 100px;
  border-radius: 20px;

  .button-text-hover {
    font-size: $paragraph-2;
    color: $color-brown;
    display: none;
  }

}

@media screen and (min-width: 768px) {
  .button-theme-solid-white:hover {
    background: $color-blue-accent;
    color: $color-white;
    transition: 0.3s ease-in-out;

    .icon-container {
      background: $color-white;
    }

    .button-text-hover {
      display: block;
    }
  }
  .button-theme-solid-grey {
    min-height: 80px;
    border-radius: 50px;

    .button-text-hover {
      display: block;
    }

    .icon-arrow-forward {
      display: none;
    }
  }
  .button-theme-solid-grey:hover {
    background: $color-blue-light;
  }

}
</style>